import Vuex from 'vuex'
import { verifycode, getUserProduct, creatTrade, getTradeById, creatPayTrade, creaTmallChpaTrade, getQRcodeBlob, redeemCoupon } from '../api'
import { findDataByid } from '../api/wfcheckpay'
import Vue from "vue";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    activeKey: '',
    activeObj: {},
    userProduct: {},
    qrUrl: null,
  },
  mutations: {
    changeKey (state, key = {}) {
      state.activeKey = key.userProductCode || ''
      state.activeObj = key || {}
    },
    changeProduct (state, key) {
      state.userProduct = key
    },
    saveQRUrl (state, key) {
      state.qrUrl = key
    }
  },
  actions: {
    // 创建订单
    creatTrade (state,{payload, callback}) {
      creatTrade(payload).then(res => {
        callback(res)
      })
    },
    // 创建支付订单
    creatPayTrade(_, {payload, callback }) {
      if(payload.payType === 'TMALL') {
        creaTmallChpaTrade(payload).then(res => {
          callback(res)
        })
      } else {
        creatPayTrade(payload).then(res => {
          callback(res)
        })
      }
    },
    // 是否支付
    requests({ state }, {payload, callback }) {
      const userProduct = state.userProduct
      verifycode(payload).then(res => {
        callback(res)
        if(res.success && res.data.payState && res.data.payState === 'PAID') {
          this.commit('check/changeKey', userProduct.userProducts[0]);
          this.commit('check/changeTradeCodeData', {})
        }
      })
    },
    // 获取产品信息
    getUserProduct(state, { payload }) {
      getUserProduct().then(res => {
        if(res && res.error_code && res.error_code === '10000') {
          let index = res.result.userProducts.findIndex(item => item.userProductCode === payload.product);
          if(index < 0) {
            index = 0
          }
          this.commit('check/changeKey', res.result.userProducts[index]);
          this.commit('check/changeProduct', res.result)
        }
      })
    },
    // 获取二维码图片Blob
    getQRcodeUrl() {
      getQRcodeBlob().then(res => {
        if(res && res.size > 0) {
          this.commit('check/saveQRUrl', window.URL.createObjectURL(res));
        }
      })
    },
    // 根据订单查详情，支付前
    getTradeById(state, { payload, callback }) {
      getTradeById(payload).then(res => {
        callback(res)
      })
    },
    // 根据查询码查结果，支付后
    findDataByid(state, { payload, callback }) {
      findDataByid(payload).then(res => {
        callback(res)
      })
    },

    // 兑换优惠券
    redeemCoupon(state, { payload, callback }) {
      redeemCoupon(payload).then(res => {
        callback(res)
      })
    },
  }
};
